import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`transaction_info`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Recommended`}</em>{`. Additional information about the name of the transaction.`}</dd></dl></p>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"transaction_info"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"source"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"route"`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`transaction_info.source`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Required`}</em>{`. This information is required by dynamic sampling.
Contains information about how the name of the transaction was determined.
This will be used by the server to decide whether or not to scrub identifiers
from the transaction name, or replace the entire name with a placeholder. The `}<inlineCode parentName="dd">{`source`}</inlineCode>{` should
only be set by integrations and not by developers directly.`}</dd></dl></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Source`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}><div style={{
              "width": "220px"
            }}>{`Examples`}</div></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`custom`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`User-defined name, see `}<a parentName="td" {...{
              "href": "https://docs.sentry.io/platforms/javascript/enriching-events/transaction-name/"
            }}><inlineCode parentName="a">{`setTransactionName()`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`my_transaction`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Raw URL, potentially containing identifiers.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/auth/login/john123/`}</inlineCode><br /><inlineCode parentName="td">{`GET /auth/login/john123/`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`route`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Parametrized URL / route`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/auth/login/:userId/`}</inlineCode><br /><inlineCode parentName="td">{`GET /auth/login/{user}/`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`view`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the view handling the request.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`UserListView`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`component`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Named after a software component, such as a function or class name.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`AuthLogin.login`}</inlineCode><br />{` `}<inlineCode parentName="td">{`LoginActivity.login_button`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`task`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of a background task (e.g. a Celery task)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sentry.tasks.do_something`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unknown`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Value set by Relay for legacy SDKs. SDKs must not set this value explicitly.`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      